interface ArrowIconProps {
  className?: string;
}

export const ArrowIcon = ({ className }: ArrowIconProps) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6199 5.2207L7.81656 9.02407C7.36739 9.47323 6.63239 9.47323 6.18323 9.02407L2.37988 5.2207"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
